var sbFilter = function () {
    return {
        restrict: "EA",
        require: ["ngModel"],
        templateUrl: "app/templates/sbFilterTemplate.html",
        scope: {
            ngModel: "=",
            onFilter: "=",
            id: "@",
            saveSession: "="
        },
        controller: ["$scope", "$sessionStorage", function ($scope, $sessionStorage) {
                if ($sessionStorage[$scope.id] && $scope.saveSession)
                    $scope.ngModel = $sessionStorage[$scope.id];
                $scope.closeFilter = function (item) {
                    item.enabled = false;
                    $scope.filter("close", item);
                };
                $scope.filter = function (type, item) {
                    if ($scope.saveSession) {
                        $sessionStorage[$scope.id] = $scope.ngModel;
                    }
                    $scope.onFilter(type, item);
                };
            }]
    };
};
angular
    .module("skillBuilderSaaS")
    .directive("sbFilter", sbFilter);
